export default {
  commands: [
    {
      type: 'TEXT',
      name: '文本',
      props: {
        name: '',
        cname: '',
        type: 'TEXT',
        mandatory: false,
        display: true,
        h5Display: false,
        tradeType: ['FOREIGN', 'INLAND'],
        fixedField: false,
        enumValues: [],
        unitFieldName: '',
        unitEnumValues: []
      }
    },
    {
      type: 'NUMBER',
      name: '数字',
      props: {
        name: '',
        cname: '',
        type: 'NUMBER',
        mandatory: false,
        display: true,
        h5Display: false,
        tradeType: ['FOREIGN', 'INLAND'],
        fixedField: false,
        enumValues: [],
        unitFieldName: '',
        unitEnumValues: []
      }
    },
    {
      type: 'DATE',
      name: '日期',
      props: {
        name: '',
        cname: '',
        type: 'DATE',
        mandatory: false,
        display: true,
        h5Display: false,
        tradeType: ['FOREIGN', 'INLAND'],
        fixedField: false,
        enumValues: [],
        unitFieldName: '',
        unitEnumValues: []
      }
    },
    {
      type: 'LINK',
      name: '超链接',
      props: {
        name: '',
        cname: '',
        type: 'LINK',
        mandatory: false,
        display: true,
        h5Display: false,
        tradeType: ['FOREIGN', 'INLAND'],
        fixedField: false,
        enumValues: [],
        unitFieldName: '',
        unitEnumValues: []
      }
    },
    {
      type: 'IMAGE',
      name: '图片',
      props: {
        name: '',
        cname: '',
        type: 'IMAGE',
        mandatory: false,
        display: true,
        h5Display: false,
        tradeType: ['FOREIGN', 'INLAND'],
        fixedField: false,
        enumValues: [],
        unitFieldName: '',
        unitEnumValues: []
      }
    }
  ],
  propsType: {
    TEXT: '文本',
    NUMBER: '数字',
    DATE: '日期',
    LINK: '超链接',
    IMAGE: '图片',
    FILE: '文件',
    ENUM: '枚举',
    NUMBER2TIMEUNIT: '时间(带单位)',
    NUMBER2VOLUME: '体积(带单位)',
    NUMBER2WEIGHT: '重量(带单位)',
    NUMBER2NETCONTENT: '净含量(带单位)',
    NUMBER2CURRENCY: '货币(带单位)',
    CATEGOTY: '行业类别',
    TRADE_TYPE: '贸易类型',
    TAG_TYPE: '标签类型',
    INSPECT_REPORT: '检测报告',
    TRACING_PLAT_INFO: '种植环境',
    TRACING_BREED_INFO: '养殖环境',
    TRACING_WORK_INFO: '生产环境',
    CERTIFICATE: '资质证书'
  }
}
